import React from 'react'

import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'

import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox'
import { MainLayout } from '../layouts'
import { SEO } from '../components'

const options = {
  buttons: {
    backgroundColor: 'white',
    iconColor: 'darkgreen',
  },
}

const textOptions = {
  renderText: text => {
    return text.split('\n').reduce((children, textSegment, index) => {
      return [...children, index > 0 && <br key={index} />, textSegment]
    }, [])
  },
}

const categoriesTemplate = ({ data }) => {
  const price = data.contentfulProducts.price
  const decPrice = price.toFixed(2)

  const variantOptions = data.contentfulProducts.variantOptions
    ? data.contentfulProducts.variantOptions.join('|')
    : null

  const variantOptionsTwo = data.contentfulProducts.variantTwoOptions
    ? data.contentfulProducts.variantTwoOptions.join('|')
    : null

  return (
    <MainLayout>
      <SEO title={data.contentfulProducts.title} />
      <div className="container infoPage">
        <div className="productContainer">
          <div className="productInfoContainer">
            <h2 className="title productTitle withLine">
              {data.contentfulProducts.title}
            </h2>
            <div className="titleLine productLine"></div>
            <p className="price">£{decPrice}</p>

            {data.contentfulProducts.variantTwoName &&
            data.contentfulProducts.variantName ? (
              <button
                class="snipcart-add-item buy-button"
                aria-label="add item to cart"
                data-item-id={data.contentfulProducts.id}
                data-item-price={price}
                data-item-weight={price}
                data-item-url={`/shop/${data.contentfulProducts.category}/${data.contentfulProducts.slug}`}
                data-item-name={data.contentfulProducts.title}
                data-item-image={data.contentfulProducts.mainImage.fluid.src}
                data-item-custom1-name={data.contentfulProducts.variantName}
                data-item-custom1-options={variantOptions}
                data-item-custom2-name={data.contentfulProducts.variantTwoName}
                data-item-custom2-options={variantOptionsTwo}
              >
                Add to cart
              </button>
            ) : data.contentfulProducts.variantName ? (
              <button
                class="snipcart-add-item buy-button"
                aria-label="add item to cart"
                data-item-id={data.contentfulProducts.id}
                data-item-price={price}
                data-item-weight={price}
                data-item-url={`/shop/${data.contentfulProducts.category}/${data.contentfulProducts.slug}`}
                data-item-name={data.contentfulProducts.title}
                data-item-image={data.contentfulProducts.mainImage.fluid.src}
                data-item-custom1-name={data.contentfulProducts.variantName}
                data-item-custom1-options={variantOptions}
              >
                Add to cart
              </button>
            ) : (
              <button
                class="snipcart-add-item buy-button"
                aria-label="add item to cart"
                data-item-id={data.contentfulProducts.id}
                data-item-price={price}
                data-item-weight={price}
                data-item-url={`/shop/${data.contentfulProducts.category}/${data.contentfulProducts.slug}`}
                data-item-name={data.contentfulProducts.title}
                data-item-image={data.contentfulProducts.mainImage.fluid.src}
              >
                Add to cart
              </button>
            )}
          </div>

          <div className="productImagesContainer">
            <SimpleReactLightbox>
              <SRLWrapper options={options}>
                <div className="productMainImage">
                  <Img
                    fluid={data.contentfulProducts.mainImage.fluid}
                    alt={data.contentfulProducts.mainImage.title}
                    style={{
                      position: 'relative',
                      maxWidth: '600px',
                      height: '100%',
                      margin: '0 auto',
                    }}
                    objectFit="cover"
                  />
                </div>
                <div className="productAltImages">
                  {data.contentfulProducts.altImages.map(img => {
                    return (
                      <div className="productAltImage" key={img.id}>
                        <Img
                          fluid={img.fluid}
                          alt={img.title}
                          style={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                          }}
                          objectFit="cover"
                        />
                      </div>
                    )
                  })}
                </div>
              </SRLWrapper>
            </SimpleReactLightbox>
          </div>
        </div>
        <div className="productRichText">
          {documentToReactComponents(
            data.contentfulProducts.description.json,
            textOptions
          )}
        </div>
        <h4 className="productRichTextTitle">
          {data.contentfulInformation.title}
        </h4>
        <div className="productRichText">
          {documentToReactComponents(data.contentfulInformation.content.json)}
        </div>
        <Link to="/shipping" className="shippingLink">
          Click here For more information about shipping
        </Link>
      </div>
    </MainLayout>
  )
}

export const getProducts = graphql`
  query getProduct($slug: String) {
    contentfulProducts(slug: { eq: $slug }) {
      id
      title
      price
      category
      slug
      variantName
      variantOptions
      variantTwoName
      variantTwoOptions
      description {
        json
      }
      mainImage {
        title
        fluid(maxWidth: 600) {
          src
          ...GatsbyContentfulFluid
        }
      }
      altImages {
        title
        fluid(maxWidth: 600) {
          ...GatsbyContentfulFluid
        }
      }
    }
    contentfulInformation(title: { eq: "Care Instructions" }) {
      title
      content {
        content
        json
      }
    }
  }
`

export default categoriesTemplate
